import * as React from "react";
import { css, cx } from "emotion";
const defaultProps = {};
const rowClass = css({
    "&:before, &:after": {
        content: '" "',
        display: "table",
    },
    "&:after": {
        clear: "both",
    },
    marginLeft: "-7.5px",
    marginRight: "-7.5px",
});
export const Row = (props) => {
    return React.createElement("div", { className: cx(rowClass) }, props.children);
};
Row.defaultProps = defaultProps;
export default Row;
//# sourceMappingURL=row.js.map